/*
  HANNE BLOCH: the other colors' first pictures, fetched ahead on the product page (HB 2026-10-15, QV round 4,
  fix 5.156). Vic: "When clicking color swatches to see another color of the product - can you remove or minimize the
  lag here? ... Perhaps when a Mini PDP or Main PDP is done loading all other relevant elements, can it in the
  background load the first picture of the swatches that are available to click for the user? ... IT SHOULD NEVER
  SLOW DOWN THE EXPERIENCE FOR THE USER. (Only add convenience and speed)".

  A color dot on the product page (product-swatch, assets/custom-quick-view.js) fetches that color's whole page and
  puts its product in place, and only then does the gallery ask for the color's pictures (measured 15 Oct on a fast
  line: the page 0.6 s, its first picture 0.2 s more; on a phone both take longer). Here the pictures wait for her:
  - Once the page has loaded and 3 s more have passed (the page's own pictures further down come first), in idle
    moments and never while she scrolls, one color at a time and at low priority: for every other color on show, the
    pictures the gallery shows first (the first on a phone, the first row of two on desktop), at the exact addresses
    the gallery will ask for (the gallery's own widths and sizes; the color's picture addresses from
    /products/<handle>.js, about 11 KB). When she taps, the browser has them: the color is complete the moment its
    page is in.
  - A check before anything is fetched: this page's own first pictures are built the same way and compared with the
    gallery's. If they differ (the gallery's markup has changed), nothing is fetched.
  - A finger on a dot (or the mouse resting on it for a moment) fetches that color first, at full priority.
  - Never on Data Saver or 2G, and no more once a picture fetched ahead shows a line under 2 Mbit/s (Safari tells no
    page the line's speed, so the first picture measures it); never for B2B buyers (the loader in
    templates/product.json); at most eight colors; nothing decoded ahead, nothing on the page changed.
  HB 2026-10-20 (Vic: the Mini PDP's colors come at once; "Please apply this to Main PDP also with same logic (i.e. it
  should never stop the first product chosen from loading, but once that is loaded then use some extra effort to
  pre-load the swatches that would be clickable)"): the color's own page comes ahead too. Not the whole page (about
  540 KB) but its two sections through the Section Rendering API in one call (the product's section and As seen on,
  about 225 KB, ?sections=): each color's sections and then its first pictures, in the same idle moments, one color
  at a time, after the same 3 s. The dot (product-swatch, assets/custom-quick-view.js) asks for them
  (window.HBSwatchAhead.sections(url)): fetched ahead, the color comes in at once; not yet, they are fetched then, at
  full priority, still a quarter of the page; without this script (B2B buyers, an old browser) the dot fetches the
  whole page as before. Kept ten minutes, then fetched again (prices and stock stay fresh). After a swap the colors
  now on show are queued (the color she left included).
  HB 2026-10-21 (Vic: "do make sure to preload product images for other colors swatches on Main PDP just like on Mini
  PDP. It makes a great difference on Mini PDP"; "don't cap colors"). Measured on the work copy: the colors' pages came
  ahead but their pictures mostly did not show from what was fetched, for two reasons, both fixed:
  - The gallery asks for widths beyond the picture's own (its srcset runs to 2560 for a 1280 px picture); the pictures
    fetched ahead left those out, so where the phone wants more than 1100 px (an iPhone Pro at 3x: 393 x 3 = 1179 px,
    so the 1300) it chose a file that was never fetched and the picture came only after the tap. Now the widths are the
    gallery's own, exactly, whenever the gallery asks upscales (checked on this page's own first picture).
  - The first pictures were found only on the first screen, 3 s after the load: a visitor who had scrolled down by then
    got the colors' pages ahead but no picture at all ("no gallery picture on the first screen"). Now the gallery's
    first row is found wherever the page is scrolled.
  And as on the Mini PDP: it starts sooner (0.8 s after the page has loaded, its own pictures being in by then; still in
  idle moments, one color at a time, at low priority, never while she scrolls), and every color comes (the cap of eight
  is gone; a Silk Tulle Top has seven others, about 1.5 MB in all over a minute or so).
  HB 2026-10-22 (Vic: "put the product's images and above the fold in 1st ranks, then all these secondary images when
  user scrolls down in 2nd rank, and then other products (i.e. swatches) in 3rd rank"; fix 5.145): on the product page
  the colors are the 3rd rank. They start once the gallery's other views and then the 2nd rank's pictures handed over
  at the load are in (the fit photos and "Follow us on Instagram" when near, the pop-ups' pictures; each step waits at
  most 2.5 s), never sooner than 0.8 s after the load (window.HBOrder, snippets/hb-pdp-order.liquid). Without it (B2B
  buyers, ?hb_order=off) 0.8 s after the load as before. state() also tells whether a color is being fetched (busy), so
  the page's last pictures wait for the colors. And the line is measured from a picture's first byte: measured from the
  request, the wait while the CDN makes a size it has not made before counted as a slow line (0.3 to 0.5 Mbit/s on a
  10 Mbit/s line, 22 Oct, desktop), and the colors stopped coming ahead after one to three of them.
  In a console: window.HBSwatchAhead.state().
*/
(function () {
  'use strict';
  if (window.HBSwatchAhead || !window.fetch || !document.querySelector) return;

  var VERSION = '2026-10-22';
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;
  var SLOW = !!(conn && (conn.saveData || /(^|-)2g$/.test(String(conn.effectiveType || ''))));
  var MAX = 40; // every color (Vic, 21 Oct: no cap); only a guard against a runaway page
  // her line, from a picture fetched ahead: its bytes over its time from the request (not its wait in line), kbit/s
  function lineKbps(im) {
    try {
      var e = im && im.currentSrc ? performance.getEntriesByName(im.currentSrc).pop() : null;
      if (!e || e.transferSize < 30000) return 0; // from the cache, or too small to tell
      // HB 2026-10-22: from the first byte; the wait before it (the CDN making a new size) is not the line's speed
      var ms = e.responseEnd - (e.responseStart > 0 ? e.responseStart : e.requestStart || e.startTime);
      return ms > 0 ? (e.transferSize * 8) / ms : 0;
    } catch (err) {
      return 0;
    }
  }
  var st = { ok: null, why: '', slots: 0, fetched: [], skipped: [], queue: [], busy: false, quiet: 0, open: false, slow: false, sections: 0, pages: [] };
  var PAGE_TTL = 10 * 60 * 1000; // a color's sections fetched ahead are used for ten minutes, then fetched again
  var ids = null; // the ids of the sections a swap needs: the product's (the container's) and As seen on, when it is there
  var pages = {}; // the color's address -> { p: a promise of a document of its sections, at: when it was asked for }
  var held = []; // the picture objects: the browser keeps their files while they are held
  var data = {}; // handle -> promise of the product's data
  var slots = null; // the gallery's first pictures: { pos, shop, sep, widths, sizes }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  // a picture's own part of its address: the product data writes "https://cdn.shopify.com/s/files/1/…/files/NAME.jpg?v=1",
  // the gallery "//hanne-bloch.com/cdn/shop/files/NAME.jpg?v=1&width=380"; both end in "files/NAME.jpg?v=1"
  var fileOf = function (u) {
    var m = String(u || '').match(/\/((?:files|products)\/[^/?#]+(?:\?[^#]*)?)$/);
    return m ? m[1] : '';
  };
  var container = function () {
    return document.querySelector('.data_fetched__and_updated_by_js');
  };

  // "…/files/NAME.jpg?v=123&width=380 380w" -> { base: "…/files/NAME.jpg?v=123", sep: "&", w: 380 }
  function parseSet(set) {
    var out = [];
    String(set || '').split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      var m = bits[0] && bits[0].match(/^(.*)([?&])width=(\d+)$/);
      if (m && bits[1]) out.push({ base: m[1], sep: m[2], w: Number(m[3]) });
    });
    return out;
  }

  // the gallery's order for one product: the chosen size's own picture first when it has one, then the rest
  // (blocks/_product-media-gallery.liquid, sorted_media)
  function order(p, variantId) {
    var media = (p && p.media) || [];
    var vs = (p && p.variants) || [];
    var v = null;
    vs.forEach(function (x) {
      if (String(x.id) === String(variantId)) v = x;
    });
    if (!v) v = vs.filter(function (x) { return x.available; })[0] || vs[0];
    var fm = v && v.featured_media;
    if (fm && fm.id) {
      var first = media.filter(function (m) { return m.id === fm.id; })[0];
      if (first) return [first].concat(media.filter(function (m) { return m.id !== fm.id; }));
    }
    return media;
  }
  var baseOf = function (m) {
    return m && m.preview_image && m.preview_image.src ? fileOf(m.preview_image.src) : '';
  };

  function product(handle, prio) {
    if (!data[handle]) {
      data[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', priority: prio || 'low' })
        .then(function (r) {
          if (!r.ok) throw new Error('hb-swatch-ahead ' + r.status);
          return r.json();
        });
      data[handle].catch(function () {
        delete data[handle];
      });
    }
    return data[handle];
  }

  // the dot's handle and size from its link ("/products/<handle>?variant=<id>"), and the address itself
  function target(sw) {
    var a = sw && sw.querySelector('a[href]');
    if (!a) return null;
    try {
      var u = new URL(a.getAttribute('href'), window.location.href);
      var m = u.pathname.match(/\/products\/([^/?#]+)/);
      return m ? { handle: decodeURIComponent(m[1]), variant: u.searchParams.get('variant'), url: u.pathname + u.search } : null;
    } catch (e) {
      return null;
    }
  }

  // The sections a swap needs, read from this page: the one holding the product container and, when the page has it,
  // the one holding As seen on (the dot's code replaces both from the color's page)
  function learnIds() {
    var c = container();
    var sec = c && c.closest ? c.closest('.shopify-section') : null;
    if (!sec || !/^shopify-section-/.test(sec.id)) return null;
    var list = [sec.id.replace(/^shopify-section-/, '')];
    var seenEl = document.querySelector('[section_main_wrapper_as_seen_on]');
    var seenSec = seenEl && seenEl.closest ? seenEl.closest('.shopify-section') : null;
    if (seenSec && /^shopify-section-/.test(seenSec.id) && seenSec !== sec) list.push(seenSec.id.replace(/^shopify-section-/, ''));
    return list;
  }
  var pageKey = function (url) {
    try {
      var u = new URL(url, window.location.href);
      return u.pathname + u.search;
    } catch (e) {
      return '';
    }
  };
  // a color's sections, as a document the dot's code can read as it reads the whole page
  function sections(url, prio) {
    var key = pageKey(url);
    if (!key || !ids) return null;
    var e = pages[key];
    if (e && Date.now() - e.at < PAGE_TTL) return e.p;
    var sep = key.indexOf('?') >= 0 ? '&' : '?';
    var p = fetch(key + sep + 'sections=' + encodeURIComponent(ids.join(',')), { credentials: 'same-origin', priority: prio === 'high' ? 'high' : 'low' })
      .then(function (r) {
        if (!r.ok) throw new Error('hb-swatch-ahead sections ' + r.status);
        return r.json();
      })
      .then(function (j) {
        var html = ids.map(function (id) { return j[id] || ''; }).join('\n');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (!doc.querySelector('.data_fetched__and_updated_by_js')) throw new Error('hb-swatch-ahead: no product in the sections');
        return doc;
      });
    pages[key] = { p: p, at: Date.now() };
    p.catch(function () {
      if (pages[key] && pages[key].p === p) delete pages[key];
    });
    return p;
  }
  var isMine = function (sw) {
    return !!sw.querySelector('.swatch.active');
  };

  // The gallery's first pictures on this page (its first row: the first picture and, beside it, the second on desktop or
  // the next one peeking on a phone; at most two), wherever the page is scrolled, and the check that this page's own
  // pictures come out of its data exactly as the gallery wrote them
  function learn() {
    var c = container();
    if (!c) return Promise.reject(new Error('no product'));
    var vw = window.innerWidth || 375;
    var shown = Array.prototype.filter.call(c.querySelectorAll('img.product-media__image'), function (img) {
      var r = img.getBoundingClientRect();
      return r.width > 40 && r.height > 40;
    });
    var top0 = shown.length ? shown[0].getBoundingClientRect().top : 0;
    var left0 = shown.length ? shown[0].getBoundingClientRect().left : 0;
    var imgs = shown
      .filter(function (img) {
        var r = img.getBoundingClientRect();
        return Math.abs(r.top - top0) < 4 && r.left - left0 < vw; // the same row, within a screen's width of the first
      })
      .slice(0, 2);
    if (!imgs.length) return Promise.reject(new Error('no gallery picture laid out'));
    var here = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!here) return Promise.reject(new Error('not a product address'));
    var variant = new URL(window.location.href).searchParams.get('variant');
    return product(decodeURIComponent(here[1]), 'low').then(function (p) {
      var list = order(p, variant);
      slots = imgs.map(function (img) {
        var set = parseSet(img.getAttribute('srcset'));
        if (!set.length) throw new Error('a gallery picture without srcset');
        set.forEach(function (e) {
          if (e.base !== set[0].base || e.sep !== set[0].sep) throw new Error('mixed addresses in one srcset');
        });
        var file = fileOf(set[0].base);
        var pos = -1;
        list.forEach(function (m, i) {
          if (pos < 0 && file && baseOf(m) === file) pos = i;
        });
        if (pos < 0) throw new Error('a gallery picture not found in the product data');
        var own = list[pos].preview_image && list[pos].preview_image.width ? list[pos].preview_image.width : 0;
        return {
          pos: pos,
          // HB 2026-10-21: the gallery asks widths beyond the picture's own (2560 for a 1280 px picture): then so do we
          up: !!own && set.some(function (e) { return e.w > own; }),
          shop: set[0].base.slice(0, set[0].base.length - file.length), // "//hanne-bloch.com/cdn/shop/"
          sep: set[0].sep,
          widths: set.map(function (e) { return e.w; }),
          sizes: (img.getAttribute('sizes') || '').replace(/^\s*auto\s*(,\s*)?/i, ''),
        };
      });
      st.slots = slots.length;
      return true;
    });
  }

  // a color's first pictures as the gallery will ask for them
  function pictures(t, prio) {
    return product(t.handle, prio === 'high' ? 'high' : 'low').then(function (p) {
      var list = order(p, t.variant);
      var waits = [];
      var ims = [];
      slots.forEach(function (s) {
        var m = list[s.pos];
        if (!m || m.media_type !== 'image') return; // a video comes with its own still
        var own = m.preview_image && m.preview_image.width ? m.preview_image.width : Infinity;
        // the gallery's own widths, exactly: with upscales when the gallery asks them (s.up), else none past the picture
        var ws = s.up ? s.widths.slice() : s.widths.filter(function (w) { return w <= own; });
        if (!ws.length) return;
        var base = s.shop + baseOf(m);
        var im = new Image();
        im.decoding = 'async';
        try {
          im.fetchPriority = prio === 'high' ? 'high' : 'low';
        } catch (e) {
          /* older browsers */
        }
        if (s.sizes) im.sizes = s.sizes;
        im.srcset = ws.map(function (w) { return base + s.sep + 'width=' + w + ' ' + w + 'w'; }).join(', ');
        ims.push(im);
        held.push(im);
        if (held.length > MAX * 2) held.shift();
        waits.push(
          new Promise(function (res) {
            var t2 = setTimeout(res, 8000);
            var done = function () {
              clearTimeout(t2);
              res();
            };
            im.addEventListener('load', done, { once: true });
            im.addEventListener('error', done, { once: true });
          })
        );
      });
      return Promise.all(waits).then(function () {
        return ims;
      });
    });
  }

  var seen = {};
  function queueAll() {
    var list = Array.prototype.filter.call(document.querySelectorAll('product-swatch'), function (sw) {
      return !isMine(sw);
    });
    list.forEach(function (sw) {
      var t = target(sw);
      if (t && !seen[t.handle] && st.queue.length + st.fetched.length < MAX) {
        seen[t.handle] = true;
        st.queue.push(t);
      }
    });
  }

  function idle(fn) {
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fn, { timeout: 1500 });
    else setTimeout(fn, 200);
  }
  function pump() {
    if (!st.ok || st.slow || st.busy || !st.queue.length) return;
    var wait = st.quiet - Date.now();
    if (document.hidden || wait > 0) {
      setTimeout(pump, Math.max(wait, 600) + 50);
      return;
    }
    st.busy = true;
    idle(function () {
      var t = st.queue.shift();
      if (!t) {
        st.busy = false;
        return;
      }
      // the color's sections first (what the tap waits for first), then its pictures; a line too weak for either stops the rest
      var sec = sections(t.url, 'low');
      (sec ? sec.then(function () { st.sections += 1; st.pages.push(t.handle); }).catch(function () {}) : Promise.resolve())
        .then(function () {
          return slots ? pictures(t, 'low') : [];
        })
        .then(function (ims) {
          st.fetched.push(t.handle);
          var kbps = Math.max.apply(null, ims.map(lineKbps).concat([0]));
          if (kbps && kbps < 2000) st.slow = true; // a weak line: the rest waits for her finger
        })
        .catch(function () {
          st.skipped.push(t.handle);
        })
        .then(function () {
          st.busy = false;
          setTimeout(pump, 250);
        });
    });
  }

  // a finger on a dot, or the mouse resting on it: that color now
  function now(sw) {
    if (!st.ok || !sw || isMine(sw)) return;
    var t = target(sw);
    if (!t) return;
    st.queue = st.queue.filter(function (q) { return q.handle !== t.handle; });
    if (st.fetched.indexOf(t.handle) >= 0) return;
    seen[t.handle] = true;
    var sec = sections(t.url, 'high');
    if (sec) sec.catch(function () {});
    if (!slots) return;
    pictures(t, 'high')
      .then(function () {
        if (st.fetched.indexOf(t.handle) < 0) st.fetched.push(t.handle);
      })
      .catch(function () {});
  }
  var hoverT = 0;
  document.addEventListener('pointerdown', function (e) {
    var sw = e.target && e.target.closest ? e.target.closest('product-swatch') : null;
    if (sw) now(sw);
  }, { passive: true, capture: true });
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var sw = e.target && e.target.closest ? e.target.closest('product-swatch') : null;
    clearTimeout(hoverT);
    if (sw) hoverT = setTimeout(function () { now(sw); }, 80);
  }, { passive: true });
  window.addEventListener('scroll', function () {
    st.quiet = Date.now() + 1000; // her own pictures further down come first while she scrolls
  }, { passive: true });

  function start() {
    if (st.open) return;
    st.open = true;
    if (SLOW) {
      st.ok = false;
      st.why = 'Data Saver or 2G';
      return;
    }
    ids = learnIds();
    learn()
      .catch(function (e) {
        // the gallery's pictures cannot be matched: the sections still come ahead, the pictures do not
        slots = null;
        st.slots = 0;
        st.why = String((e && e.message) || e);
        if (!ids) throw e;
      })
      .then(function () {
        st.ok = true;
        queueAll();
        pump();
      })
      .catch(function (e) {
        st.ok = false;
        st.why = String((e && e.message) || e);
      });
  }
  // after a swap the dots are new ones and the color she left is another color now: queued once the page has settled
  function requeue() {
    setTimeout(function () {
      if (!st.ok || st.slow) return;
      queueAll();
      pump();
    }, 1500);
  }
  // HB 2026-10-21: 0.8 s after the load, as the Mini PDP starts once its own pictures are in (was 3 s); by the load
  // event the gallery's own pictures (eager) have come
  function later() {
    // HB 2026-10-22: on the product page the 2nd rank's pictures come first (window.HBOrder says when)
    if (window.HBOrder && typeof window.HBOrder.afterSecond === 'function') {
      window.HBOrder.afterSecond(function () {
        idle(start);
      });
      return;
    }
    setTimeout(function () {
      idle(start);
    }, 800);
  }
  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later, { once: true });

  window.HBSwatchAhead = {
    version: VERSION,
    state: function () {
      return { ok: st.ok, why: st.why, slots: st.slots, sections: ids ? ids.slice() : null, pagesAhead: st.pages.slice(), fetched: st.fetched.slice(), skipped: st.skipped.slice(), waiting: st.queue.length, busy: st.busy, open: st.open, dataSaver: SLOW, slowLine: st.slow };
    },
    // the dot's code (assets/custom-quick-view.js): the color's sections as a document, fetched ahead or now; null
    // when this page's sections are not known (the dot then fetches the whole page as before)
    sections: function (url) {
      if (!ids) ids = learnIds();
      var p = sections(url, 'high');
      if (p) requeue();
      return p;
    },
  };
})();
